import { initTheme } from "@/utils/theme";

import { IChannelConfigs, IChannelTheme } from "../types";
import LuxyGlobalFooter from "./components/Layout/Footer.vue";
const theme: IChannelTheme = {};

export default {
  configs: {
    key: "luxyglobal",
    currency: "MYR",
    components: {
      Footer: {
        component: LuxyGlobalFooter
      }
    },
    pages: {
      Index: {
        featuredHotels: [
          // Rosewood Hong Kong (Code: E8048)
          "5c0e8df1f2cb097966521d28",
          // Aman Tokyo (Code: B1020)
          "5b506a4d6a8860a3024d8947",
          // Mandarin Oriental Qianmen, Beijing (Code: I4230)
          "669f3ae788aba06a179e08da",
          // W Shanghai (Code: C8284)
          "5b50768d6a8860a3024dfee9"
        ],
        banners: {
          list: [
            {
              img: "https://uploads.ytripos.com/uploaded/FvqRWFs7vLqkYwsIhDMcMBD40ddF/241770874661.jpg"
            }
          ]
        }
      }
    }
  },
  init() {
    initTheme(theme);
  }
} as IChannelConfigs;
